import config from '../config';
import ChargebeeClient from './chargebee/ChargebeeClient';

const chargebeeClient = new ChargebeeClient(config.chargebeeSite);

export default chargebeeClient;
